<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div class="dialogData" v-loading="trackloading">
      <div v-if="!trackloading">
        <div class="qwq" v-if="!list.IsExpressType">
          <div>
            <h3 class="steps_h3" v-if="!isExp">{{ $t('alert.youItemInformation') }}</h3>
            <h3 class="steps_h3" v-if="isExp">{{expList.State>=3?$t('alert.youItemDelivered'):$t('alert.youItemTransit') }}</h3>
            <div class="steps_box">
              <div>
                <div class="dot first greed">
                  <span class="yes el-icon-check"></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div class="steps_txt first">
                  {{ $t('base.shipped') }}<br>{{expList.ldate|setTimeS}}
                </div>
              </div>
              <div>
                <div class="dot" :class="expList.State>=2?'greed':''">
                  <span></span>
                  <span></span>
                  <span class="yes el-icon-check"></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div class="steps_txt">
                  {{ $t('base.inTransit') }}
                </div>
              </div>
              <div>
                <div class="dot" :class="expList.State>=3?'greed':''">
                  <span></span>
                  <span></span>
                  <span class="yes el-icon-check"></span>
                </div>
                <div class="steps_txt">
                  {{ $t('base.delivered') }}<br>{{expList.ndate|setTimeS}}
                </div>
              </div>
            </div>
            <div class="steps_title">{{list.ExpressCode}}<span class="text_blue">#{{list.ExpressNumber}}</span></div>
          </div>
        </div>
        <div v-else class="qwq">
          <div>
            <h3 class="steps_h3" v-if="!isExp">{{ $t('alert.youItemInformation') }}</h3>
            <h3 class="steps_h3" v-if="isExp">{{expList.State>=3?$t('alert.youItemDelivered'):$t('alert.youItemTransit') }}</h3>
            <div class="steps_title">{{list.LogisticsCompanyCode}}<span class="text_blue">#{{list.LogisticsCode}}</span></div>
          </div>
        </div>
        <el-scrollbar>
          <div class="track_box_dialog" ref="getHeight" v-if="isExp&&!list.IsExpressType">
            <div class="steps_list" v-for="(item,index) in expList.Traces" :key='index'>
              <div class="steps_list_up">
                <span class="time">{{item.AcceptTime|setTimeSS}}</span>
                <span class="dott"></span>
                <span class="add">{{item.AcceptStation}}</span>
              </div>
              <div class="steps_line"></div>
            </div>
          </div>
          <div class="track_box_dialog" ref="getHeight" v-if="isExp&&list.IsExpressType==1">
            <div class="steps_list" v-for="(item,index) in expList.TrackList" :key='index'>
              <div class="steps_list_up">
                <span class="time">{{item.TrackDate|setTimeSS}}</span>
                <span class="dott"></span>
                <span class="add">{{item.TrackStatus}}</span>
              </div>
              <div class="steps_line"></div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div slot="footer" class="dialog_footer" style="margin: 0;">
      <el-button type="primary" @click="handleClose">{{ $t('base.ok') }}</el-button>
    </div>
  </el-dialog>
  <!-- <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div class="dialogData" v-loading="trackloading">
      <h3 class="steps_h3" style="font-size:14px;" v-if="expList==null">Your item has no logistics information.</h3>
      <h3 class="steps_h3" v-if="expList!=null">Your item was delivered.</h3>
      <div v-if="expList!=null">
        <div class="steps_box">
          <div>
            <div class="dot first greed">
              <span class="yes el-icon-check"></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="steps_txt first">
              Shipped<br>{{expList.ldate|setTimeS}}
            </div>
          </div>
          <div>
            <div class="dot" :class="expList.State>=2?'greed':''">
              <span></span>
              <span></span>
              <span class="yes el-icon-check"></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="steps_txt">
              In transit
            </div>
          </div>
          <div>
            <div class="dot" :class="expList.State>=3?'greed':''">
              <span></span>
              <span></span>
              <span class="yes el-icon-check"></span>
            </div>
            <div class="steps_txt">
              Delivered<br>{{expList.ndate|setTimeS}}
            </div>
          </div>
        </div>
        <div class="steps_title">{{expList.ShipperCode}}<span class="text_blue">#{{expList.LogisticCode}}</span></div>

        
        <div class="track_box_dialog" style="height:1000px;">
          <div class="steps_list" v-for="(item,index) in expList.Traces" :key='index'>
            <div class="steps_list_up">
              <span class="time">{{item.AcceptTime|setTimeSS}}</span>
              <span class="dott"></span>
              <span class="add">{{item.AcceptStation}}</span>
            </div>
            <div class="steps_line"></div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog_footer" style="margin: 0;">
      <el-button type="primary" @click="handleClose">OK</el-button>
    </div>
  </el-dialog> -->
</template>
<script>
import { getTime } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      expList: null,
      isExp: false,
      trackloading: true,
      listHeight: 0,
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {}
  },
  filters: {
    setTimeS(val) {
      if (val) {
        val = val.toString().replace(/-/g, "/")
      }
      var time = getTime(val, -8, 0, 'cn')
      return time.indexOf('Invalid') != -1 ? '' : time
    },
    setTimeSS(val) {
      if (val) {
        val = val.toString().replace(/-/g, "/")
      }
      var time = getTime(val, -8, 0, 'cn')
      return time.indexOf('Invalid') != -1 ? '' : time
    },
  },
  created() {
    this.GetExpress(this.list)
  },
  mounted() {
    let that = this
    // that.$nextTick(() => {
    //   this.listHeight = this.$refs.getHeight.offsetHeight;
    //   console.log(this.listHeight)
    // })
  },
  methods: {
    handleClose() {
      this.$emit('closeDialog', 'express', false)
    },
    // 获取订单物流信息
    GetExpress(obj) {
      let that = this;
      that.expList = '';
      that.isExp = false
      that.trackloading = true
      if (!that.list.IsExpressType) {
        that.GetOrdinaryExpress(obj)
      } else {
        that.GetStoreExpress(obj)
      }
    },
    // 普通订单物流
    GetOrdinaryExpress(obj) {
      let that = this;

      that.trackloading = false
      let data = { LogisticCode: obj.ExpressNumber, ShipperCode: obj.ExpressCode, Mobile: obj.ExpressPhone, OrderCode: obj.ID }
      //let data = { LogisticCode: 'SF0281281553683', ShipperCode: 'SF', Mobile: obj.Mobile, OrderCode: obj.ID }
      this.$get(this.$interface.GetExpressInfoByShipperCode, data).then(res => {
        if (res.Result != 0) {
          if (res.Data == null) {
            that.expList = res.Data
          } else {
            if (res.Data.Traces.length > 0) {
              res.Data.ldate = res.Data.Traces[0].AcceptTime
              if (res.Data.State == '3') {
              //console.log(res.Data.State,'123')
                let leng = res.Data.Traces.length - 1
                res.Data.ndate = res.Data.Traces[leng].AcceptTime
              }
              if(res.Data.ldate>res.Data.ndate&&(res.Data.ldate&&res.Data.ndate)){
                res.Data.ldate=res.Data.ndate
                res.Data.ndate = res.Data.Traces[0].AcceptTime
              }
              that.isExp = true
              that.expList = res.Data
            } else {
              that.expList = res.Data
            }
          }
        } else {
          that.expList = res.Data
        }
        that.trackloading = false
        //console.log(res)
      })
    },
    // 新官方商城物流
    GetStoreExpress(obj) {
      let that = this;
      let data = { OrderId: obj.Id, shipperCode: obj.LogisticsCompanyCode, logisticCode: obj.LogisticsCode }
      //let data = { "OrderId": "5061677704650192080", "shipperCode": "YTO", "logisticCode": "YT1819952506580" }
      this.$post(this.$interface.GetExpressSubscribeInfo, data).then(res => {
        if (res.Result != 0) {
          var data = res.Data
          if (res.Data.length > 0) {
            data[0].Tracklist.LogisticCode = data[0].LogisticCode
            data[0].Tracklist.ShipperCode = data[0].ShipperCode
            that.expList = data[0].Tracklist
            that.isExp = true
          }
        }

        that.trackloading = false
      })
    }
  },

}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";

/deep/ .el-dialog__body {
  padding: 12px 20px;
}

/deep/ .el-dialog {
  overflow-y: hidden;
}

.track_box_dialog {
  min-height: 0px;
  max-height: 200px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/express.vue